export default "__VITE_PUBLIC_ASSET__e9036d90__"